import SettleInstallmentPartiallyModal from '@/components/_common/SettleInstallmentPartiallyModal';
import { SettleInstallmentPartiallyFormValues } from '@/components/_common/SettleInstallmentPartiallyModal/SettleInstallmentPartiallyForm/types';
import { SettleInstallmentPatiallyModalProps } from '@/components/_common/SettleInstallmentPartiallyModal/types';
import { useAccountReceivableSettlePartiallyInstallment } from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { handleInstallmentAlreadyEdited } from '@/core/domain/financial/AccountReceivable/AccountRecivable.errors';
import { DateTimeFormat } from '@/utils/moment';
import { AxiosError } from 'axios';

type Props = Omit<SettleInstallmentPatiallyModalProps, 'onOk'>;

const AccountReceivablePartiallyInstallmentModal: React.FC<Props> = (props) => {
  const settlePartiallyInstallment =
    useAccountReceivableSettlePartiallyInstallment();

  async function onOk(data: SettleInstallmentPartiallyFormValues) {
    try {
      if (typeof data.bankAccountId === 'number') {
        await settlePartiallyInstallment.mutateAsync({
          ...data,
          bankAccountId: data.bankAccountId,
          payDate: data.payDate.format(DateTimeFormat),
          dueDate: data.dueDate.format(DateTimeFormat),
          currentSituation: props.data?.currentSituation,
        });
      }
    } catch (err: unknown) {
      const error = err as AxiosError;

      if (error.response?.data) {
        if (handleInstallmentAlreadyEdited(error)) {
          props.onCancel();
        }
      }
    }
  }

  return (
    <SettleInstallmentPartiallyModal
      {...props}
      onOk={onOk}
      confirmLoading={settlePartiallyInstallment.isLoading}
    />
  );
};

export default AccountReceivablePartiallyInstallmentModal;
